import notificationService from "data/notification";
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from "react";

const Toasts = () => {
  const toast = useRef<null | Toast>(null)

  useEffect(() => {
    notificationService.stream().subscribe(n => {
      toast && toast.current?.show({
        severity: n.type == 'danger' ? 'error' : n.type,
        sticky: n.sticky ? true : false,
        content: (props) => <div>{n.message}</div>
      });
    })
  });

  return (
    <Toast ref={toast} />
  )
}

export default Toasts
